var Top = /** @class */ (function () {
    function Top() {
        this.init();
    }
    Top.prototype.init = function () {
        var _this = this;
        $(window).on('scroll', function (event) {
            _this.scroll(event);
        });
    };
    Top.prototype.ready = function () {
        $('.main_copy').addClass('show');
        $('.mv_img').addClass('show');
    };
    Top.prototype.load = function () { };
    Top.prototype.scroll = function (event) {
        var scTop = $(window).scrollTop();
        var wid = $(window).innerWidth();
        //side
        var sideTop = wid > 640 ? $('.about').offset().top : $('.about .right_column').offset().top;
        if (sideTop <= scTop && !$('.about .side_txt').hasClass('sticky')) {
            $('.about .side_txt').addClass('sticky');
        }
        else if (sideTop > scTop && $('.about .side_txt').hasClass('sticky')) {
            $('.about .side_txt').removeClass('sticky');
        }
    };
    return Top;
}());
export { Top };
(function () {
    var top = new Top();
    $(document).ready(function () {
        top.ready();
    });
    window.addEventListener('load', function () {
        top.load();
    });
})();
